<template>
    <div class="c-footer-detail">
        <LayoutContent>
            <div class="c-footer-detail-box">
                <div class="content-side">
                    <div class="c-footer-detail-side-link">
                        <div class="c-footer-detail-logo">
                            <a href="/"><i class="c-nav-logo"></i></a>
                        </div>
                        <ul class="c-media-link">
                            <li class="link-item">
                                <div class="c-link-tip is-qq">
                                    <span class="c-link-logo">
                                        <i class="gvfont gvfont-qq"></i>
                                    </span>
                                    <span class="link-text">GCloud助手</span>
                                    <span class="tip-box">
                                        <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/gcloud-code-qq.png" width="144px" />
                                    </span>
                                </div>
                            </li>
                            <li class="link-item">
                                <a href="mailto:rogerhan@tencent.com" class="c-link-tip is-mail">
                                    <span class="c-link-logo">
                                        <i class="gvfont gvfont-mail"></i>
                                    </span>
                                    <span class="link-text">rogerhan@tencent.com</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content-main">
                    <div class="c-main-link-box">
                        <dl class="c-link-list-inner">
                            <dt class="list-title">{{ $t("main:产品") }}</dt>
                            <dd class="list-item">
                                <a href="/product" class="item-text">{{ $t("main:游戏语音") }}</a>
                            </dd>
                            <!-- <dd class="list-item">
                                <a href="javascript:;" class="item-text">{{ $t("main:社交IM") }}</a>
                            </dd>
                            <dd class="list-item">
                                <a href="javascript:;" class="item-text">{{ $t("main:在线会议") }}</a>
                            </dd>
                            <dd class="list-item">
                                <a href="javascript:;" class="item-text">{{ $t("main:视频直播") }}</a>
                            </dd>
                            <dd class="list-item">
                                <a href="javascript:;" class="item-text">{{ $t("main:短视频") }}</a>
                            </dd> -->
                        </dl>
                        <dl class="c-link-list-inner">
                            <dt class="list-title">{{ $t("main:开发者") }}</dt>
                            <dd class="list-item">
                                <a href="/sdk" class="item-text">{{ $t("main:SDK下载") }}</a>
                            </dd>
                            <dd class="list-item">
                                <a href="https://docs.qq.com/pdf/DV3pET2RIdXpqTEh1" target="_blank" class="item-text">{{ $t("main:文档") }}</a>
                            </dd>
                            <!-- <dd class="list-item">
                                <a href="javascript:;" class="item-text">{{ $t("main:GVoice官方GitHub") }}</a>
                            </dd> -->
                            <!-- <dd class="list-item">
                                <a href="javascript:;" class="item-text">{{ $t("main:服务支持") }}</a>
                            </dd> -->
                        </dl>
                        <dl class="c-link-list-inner">
                            <dt class="list-title">{{ $t("main:开始体验") }}</dt>
                            <dd class="list-item">
                                <a href="javascript:;" class="item-text" @click="handleLogin">{{ $t("main:登录") }}</a>
                            </dd>
                            <!-- <dd class="list-item">
                                <a href="javascript:;" class="item-text">{{ $t("main:关于我们") }}</a>
                            </dd> -->
                        </dl>
                        <!-- <dl class="c-link-list-inner">
                            <dd class="list-item">
                                <a href="javascript:;" class="item-text"
                                    ><span class="c-icon-text"
                                        ><span class="icon-space"><i class="gvfont gvfont-intl"></i></span><span class="text-space">Intl-English</span></span
                                    ></a
                                >
                            </dd>
                        </dl> -->
                    </div>
                </div>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
import { jumpLogin } from "@/utils/commons";

export default {
    name: "FooterDetail",
    components: { LayoutContent },
    methods: {
        // 跳转登录页面
        handleLogin() {
            jumpLogin(window.location.href);
        },
    },
};
</script>
<style scoped lang="less">
.c-footer-detail-box {
    display: flex;
    justify-content: space-between;
    padding-left: 24px;
    padding-right: 24px;
    .content-side {
        & + .content-main {
            margin-left: 64px;
        }
    }
}
.c-nav-logo {
    display: inline-block;
    width: 320px;
    height: 36px;
    background: url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-tencent-game-gvoice.png) no-repeat center center;
    background-size: contain;
}
.c-link-tip {
    display: inline-flex;
    align-items: center;
    user-select: none;
    position: relative;
    &:hover {
        &.is-qq {
            .c-link-logo {
                border-color: #fd8577;
                .gvfont-qq {
                    color: #fd8577;
                }
            }
        }
        &.is-mail {
            .c-link-logo {
                border-color: #277ff3;
                .gvfont-mail {
                    color: #277ff3;
                }
            }
        }
        .link-text {
            color: #fff;
        }
        .tip-box {
            width: 144px;
            height: 144px;
            left: calc(~"100% + 24px");
            overflow: visible;
            transition: ease-in-out 0.16s;
            &::before {
                opacity: 1;
            }
            img {
                opacity: 1;
            }
        }
    }
    .c-link-logo {
        & + .link-text {
            margin-left: 8px;
        }
    }
    .link-text {
        font-size: 16px;
        color: #8a8c94;
    }
    .tip-box {
        display: inline-flex;
        width: 0;
        height: 0;
        position: absolute;
        top: 0;
        left: 100%;
        z-index: 33;
        overflow: hidden;
        transition: ease-in-out 0.16s;
        &::before {
            content: "";
            display: inline-flex;
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-right: 8px solid #fff;
            opacity: 0;
            position: absolute;
            right: calc(100% - 1px);
            border-radius: 2px;
        }
        img {
            width: 100%;
            border-radius: 2px;
            position: relative;
            z-index: 2;
            opacity: 0;
        }
    }
}
.c-link-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #8a8c94;
    .gvfont {
        margin-top: 2px;
        font-size: 14px;
        color: #8a8c94;
    }
}
.c-footer-detail-logo {
    & + .c-media-link {
        margin-top: 24px;
    }
}
.c-media-link {
    display: flex;
    flex-direction: column;
    .link-item {
        & + .link-item {
            margin-top: 24px;
        }
    }
}
.c-footer-detail-box {
    padding-top: 60px;
    padding-bottom: 60px;
}
.c-link-list-inner {
    & + .c-link-list-inner {
        margin-left: 56px;
    }
    .list-title {
        font-size: 14px;
        color: #bbbbbb;
        & + .list-item {
            margin-top: 24px;
        }
    }
    .list-item {
        & + .list-item {
            margin-top: 16px;
        }
        .item-text {
            font-size: 14px;
            color: #fff;
            opacity: 0.4;
            &:hover {
                opacity: 1;
            }
            .gvfont-intl {
                font-size: 20px;
            }
        }
    }
}
.c-icon-text {
    display: flex;
    align-items: center;
    .icon-space {
        & + .text-space {
            margin-left: 14px;
        }
    }
}
.c-main-link-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 400px;
}

@media only screen and (max-width: 768px) {
    .c-footer-detail-box {
        flex-direction: column;
        padding-top: 24px;
        padding-bottom: 24px;
        .content-side {
            & + .content-main {
                margin-left: 0;
                margin-top: 32px;
            }
        }
    }
}
@media only screen and (max-width: 480px) {
    .c-nav-logo {
        width: 200px;
        height: 24px;
    }

    .c-link-list-inner {
        width: 50%;
        & + .c-link-list-inner {
            margin-top: 0;
            margin-left: 24px;
        }
        .list-title {
            & + .list-item {
                margin-top: 16px;
            }
        }
        .list-item {
            & + .list-item {
                margin-top: 8px;
            }
            .item-text {
                font-size: 12px;
            }
        }
    }
    .c-footer-detail-logo {
        & + .c-media-link {
            margin-top: 16px;
        }
    }
    .c-link-tip {
        .link-text {
            font-size: 12px;
        }
    }
    .c-media-link {
        .link-item {
            & + .link-item {
                margin-top: 8px;
            }
        }
    }
}
</style>
